import APIKit from "../Allapis/Apikit/apikit";

export const getNotifications = async (params) => {
  try {
    const url = `/notification`;
    const { name, userId, email, role } = params;
    const res = await APIKit.get(url, {
      params: { name, userId, email, role },
    });

    return res.data;
  } catch (e) {
    console.log(e);
  }
};
export const getNotificationList = async () => {
  try {
    const url = `/notifications/List`;
    const res = await APIKit.get(url);
    return res.data;
  } catch (e) {
    console.log(e, "Error in Fetching Notifications");
  }
};

// export const uploadImageNotification = async (file) => {
//   const res = await APIKit.post(`/notifications/notification-upload`, file, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
//   console.log("res", res);
//   return res.data;
// };
export const sendNotications = async (values) => {
  console.log({ Values1234567890: values });
  try {
    const res = await APIKit.post(`/notifications`, values);
    console.log({ res1234567: res });
    return res.data;
  } catch (e) {
    console.log(e, "Error in send Notifications");
  }
};
